import { useAccountDetailsContext } from "@/components/modules/pipeline/account-details/context";
import { clsxMerge } from "shared/lib/helpers";

import { FC } from "react";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

export const EmailTemplatesSidebarHeader: FC<PropsWithClassNameI> = ({
  className,
}) => {
  const { focusedContact } = useAccountDetailsContext();

  return (
    <div
      className={clsxMerge("p-5 pb-0 typography-header-7-semibold", className)}
    >
      <h2>
        Email - {focusedContact?.first_name} {focusedContact?.last_name}
      </h2>
    </div>
  );
};
